import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

// Dev-only marker on MVP stand-ins (Stage renders, sample reviews) so they can't
// quietly ship to public as truth. import.meta.env.DEV is statically false in a
// production build, so this component and its markup vanish from the prod bundle.
// The parent must be `relative` (the badge is absolutely positioned).
export function PlaceholderBadge({ className }: { className?: string }) {
  const { t } = useTranslation("landing");
  if (!import.meta.env.DEV) return null;
  return (
    <span
      data-testid="landing-placeholder"
      className={cn(
        "pointer-events-none absolute left-2 top-2 z-10 rounded bg-alert px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-white shadow-sm",
        className,
      )}
    >
      {t("dev.placeholder")}
    </span>
  );
}
